import React from 'react';
import { StarIcon } from 'lucide-react';
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/1gUkHJdjoZxsa6yN2ATc6t/ChatGPT_Image_26_may_2026,_22_10_18.png';
export function Header() {
  return <header className="w-full sticky top-0 z-50 bg-charcoal/90 backdrop-blur-md border-b border-gold/15" data-id="element-108">
      <div className="max-w-6xl mx-auto px-3 sm:px-6 h-12 sm:h-14 flex items-center justify-between gap-3 sm:gap-6" data-id="element-109">
        {/* Logo */}
        <img src={LOGO_SRC} alt="Ascend" className="h-9 sm:h-11 w-auto select-none pointer-events-none shrink-0" draggable={false} data-id="element-110" />

        {/* Trust + price strip */}
        <div className="min-w-0" data-id="element-111">
          {/* Mobile: compact version */}
          <div className="flex sm:hidden items-center gap-1.5 text-[10px] text-ivory/75 tracking-wide whitespace-nowrap" data-id="element-112">
            <StarIcon className="w-2.5 h-2.5 fill-current text-gold shrink-0" data-id="element-113" />
            <span data-id="element-114">1,200+ readers</span>
            <span className="text-ivory/30" data-id="element-115">·</span>
            <span data-id="element-116">
              <span className="text-gold font-medium" data-id="element-117">$14.99</span>
              <span className="text-ivory/40 italic ml-1" data-id="element-118">($29.99)</span>
            </span>
          </div>

          {/* Desktop: full version */}
          <div className="hidden sm:flex items-center gap-2.5 text-[13px] text-ivory/75 tracking-wide whitespace-nowrap" data-id="element-119">
            <StarIcon className="w-3.5 h-3.5 fill-current text-gold shrink-0" data-id="element-120" />
            <span data-id="element-121">Trusted by 1,200+ readers</span>
            <span className="text-ivory/30" data-id="element-122">·</span>
            <span data-id="element-123">
              Launch price <span className="text-gold font-medium" data-id="element-124">$14.99</span>
            </span>
            <span className="text-ivory/40 italic" data-id="element-125">(regularly $29.99)</span>
          </div>
        </div>
      </div>
    </header>;
}